import axios from 'axios';
const instanceApiVenda = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL,
    headers: {
        'Authorization': process.env.VUE_APP_API_BEARER,
        ['keyApiVendas']: process.env.VUE_APP_API_KEY_VENDAS
    }
})

const GET_VENDAS = (url: string | void) => instanceApiVenda.get(url || "").then(res => res.data).then(res => {
    return res
}).catch(e => {

    throw e.response.data.message
})

const POST_VENDAS = (url: string | void, params: object | Array<any | void> | void) => instanceApiVenda.post(url || "", params).then(res => res.data).then(res => {
    return res
}).catch(e => {

    throw e.response.data.message
})

const PUT_VENDAS = (url: string | void, params: object | Array<any> | void) => instanceApiVenda.put(url || "", params).then(res => res.data).then(res => {
    return res
}).catch(e => {

    throw e.response.data.message
})

const DELETE_VENDAS = (url: string | void) => instanceApiVenda.delete(url || "").then(res => res.data).then(res => {
    return res
}).catch(e => {

    throw e.response.data.message
})

export { GET_VENDAS,  POST_VENDAS,  PUT_VENDAS,  DELETE_VENDAS, instanceApiVenda };